export var SapIngestionMode;
(function (SapIngestionMode) {
    SapIngestionMode["SAP_INGESTION_MODE_FULL"] = "FULL";
    SapIngestionMode["SAP_INGESTION_MODE_FULL_DELTA"] = "FULL_DELTA";
    SapIngestionMode["SAP_INGESTION_MODE_DELTA_ONLY"] = "DELTA_ONLY";
})(SapIngestionMode || (SapIngestionMode = {}));
